
import * as defaultImport from "@splunk/react-ui/Progress";
export * from "@splunk/react-ui/Progress";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
